export function getSearchTermsFromQuery(query: string): string[]
{
    return query.match(/\S+/g);
}
